<template>
  <RfSimpleCard class="p-10">
    <div class="settings-actions-tabs mx-0! mt-0!">
      <div :class="{ selectedTab: selectedTab === 'messages' }">
        <button @click="selectedTab = 'messages'">Messages</button>
      </div>
      <div
        v-if="app.flags.app_notifications_enabled"
        :class="{ selectedTab: selectedTab === 'notifications' }"
      >
        <button @click="selectedTab = 'notifications'">Notifications</button>
      </div>
    </div>
    <RfAppMessage v-if="selectedTab === 'messages'" :messages="app.messages" />
    <RfAppNotification
      v-if="selectedTab === 'notifications' && app.flags.app_notifications_enabled"
      ref="appMessagesNotificationsRef"
      :appNotifications="appsStore.appNotifications"
      :app="app"
    />
  </RfSimpleCard>
</template>

<script setup>
import { ref, onMounted, computed, useTemplateRef } from "vue";
import { useAppsStore } from "@/pinia/appsStore";
import RfAppMessage from "./RfAppMessage.vue";
import RfAppNotification from "./RfAppNotification.vue";
import RfSimpleCard from "@/components/RfSimpleCard.vue";

const props = defineProps({
  app: {
    type: Object,
    required: true,
  },
});

const selectedTab = ref("messages");
const appMessagesNotificationsRef = useTemplateRef("appMessagesNotificationsRef");
const appsStore = useAppsStore();

onMounted(() => {
  if (props.app.flags.app_notifications_enabled) appsStore.getAppNotifications(props.app.id);
});

defineExpose({
  selectedTab,
  disabledAppNotifications: computed(() => appMessagesNotificationsRef.value?.disabled),
  submitAppNotifications: () => appMessagesNotificationsRef.value?.submit?.(),
});
</script>
